import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { AxiosInstance } from 'axios'

import { EapToHpiBannerStatus } from '@lyrahealth-inc/shared-app-logic/src/features/eligibility/types'

import { fetchEapHpiBannerState, setEapHpiBannerStateIsLoaded } from './eapHpiBannerActions'
import { getEapHpiBannerStatus } from './eapHpiBannerSelectors'
import { getIsEapHpiInProductNotificationsEnabled } from '../featureFlags/featureFlagSelectors'
import { useAppDispatch } from '../storeConfiguration/store'
import { getId } from '../user/userSelectors'

interface UseEapHpiBannerDataProps {
  axiosInstance: AxiosInstance
}

/**
 * Redux-aware hook for accessing EAP to HPI banner data
 * Automatically fetches banner data when conditions are met
 */
export const useEapHpiBannerData = ({ axiosInstance }: UseEapHpiBannerDataProps): EapToHpiBannerStatus => {
  const dispatch = useAppDispatch()
  const isFeatureEnabled = useSelector(getIsEapHpiInProductNotificationsEnabled)
  const userLyraId = useSelector(getId)
  const bannerStatus = useSelector(getEapHpiBannerStatus)

  useEffect(() => {
    if (isFeatureEnabled && userLyraId) {
      dispatch(fetchEapHpiBannerState({ userLyraId, axiosInstance }))
    } else if (!isFeatureEnabled) {
      dispatch(setEapHpiBannerStateIsLoaded(true))
    }
  }, [isFeatureEnabled, userLyraId, dispatch, axiosInstance])

  return bannerStatus?.toJS() as EapToHpiBannerStatus
}
